import SloganCarousel from "./slogan-carousel/SloganCarousel";
import TrendingDraws from "./trending-draws/TrendingDraws";
import HowItWorks from "./how-it-works/HowItWorks";
import {useEffect} from "react";
import WhyGenie from "./why-genie/WhyGenie";
import {useAppDispatch} from "../../store";
import {getHomeContent} from "../../store/home/ActionCreators";
import PastWishes from "./past-wishes/PastWishes";
import TrendingVouchers from "./trending-vouchers/TrendingVouchers";

const Home = () => {
    const dispatch = useAppDispatch()

    useEffect(() => {
        dispatch(getHomeContent())
        // dispatch(getCategories({}))
    }, [dispatch])

    return (
        <>
            <SloganCarousel/>
            <TrendingDraws/>
            <PastWishes/>
            <HowItWorks/>
            <WhyGenie/>
            <TrendingVouchers/>
            {/*<Partners />*/}
        </>
    )
}

export default Home
